export default "__VITE_ASSET__PtnImXzs__"